// extracted by mini-css-extract-plugin
module.exports = {"l1o26rgz":"l1o26rgz"};